import React, { useEffect, useRef } from 'react';

const GaugeComponent = ({ value = 50, min = 0, max = 100, size = 200 }) => {
  const gaugeRef = useRef(null);

  useEffect(() => {
    const range = max - min;

    const updateGauge = () => {
      const angle = ((value - min) / range) * 180;
      const color = getColor(value);

      if (gaugeRef.current) {
        gaugeRef.current.style.transform = `rotate(${angle}deg)`;
        gaugeRef.current.style.stroke = color;
      }
    };

    const getColor = (value) => {
      if (value < min + 0.25 * range) return "#1772DC"; // Change color to #1772DC
      if (value < min + 0.5 * range) return "#fffa50";
      if (value < min + 0.75 * range) return "#f7aa38";
      return "#ef4655";
    };

    updateGauge();
  }, [value, min, max]);

  // Inline styles
  const wrapperStyle = {
    margin: '0 auto',
    position: 'relative',
    width: size,
    height: size / 2,
  };

  const gaugeContainerStyle = {
    position: 'relative',
    width: '100%',
    height: '100%',
  };

  const gaugeStyle = {
    width: '100%',
    height: '100%',
  };

  const dialStyle = {
    stroke: '#334455',
    strokeWidth: 10,
    fill: 'none',
  };

  const valueStyle = {
    stroke: 'orange',
    strokeWidth: 10,
    fill: 'none',
    transition: 'transform 0.3s ease, stroke 0.3s ease',
    transformOrigin: '50% 100%',
  };

  const valueTextStyle = {
    fill: '#ccc',
    fontWeight: 400,
    fontSize: '1.5em',
    position: 'absolute',
    top: '80%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  };

  return (
    <div style={wrapperStyle}>
      <div style={gaugeContainerStyle}>
        <svg style={gaugeStyle} viewBox="0 0 100 50">
          <path style={dialStyle} d="M10,50 A40,40 0 1,1 90,50" />
          <path ref={gaugeRef} style={valueStyle} d="M10,50 A40,40 0 1,1 90,50" />
        </svg>
        <div style={valueTextStyle}>{value}</div>
      </div>
    </div>
  );
};

export default GaugeComponent;
